import { SiteWithModuleStatusDto } from "../../../models/site-with-module-status";
import { ALL_SITES_EXCLUDED_SITE } from "./constants";

export function getAllSitesSelection(
  sites: SiteWithModuleStatusDto[]
): string[] {
  return sites
    .filter((p) => p.moduleEnabled && p.site !== ALL_SITES_EXCLUDED_SITE)
    .map((p) => p.site);
}
